var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1562 2.17969H9.84375C8.60273 2.17969 7.59375 3.18867 7.59375 4.42969V31.4297C7.59375 32.6707 8.60273 33.6797 9.84375 33.6797H26.1562C27.3973 33.6797 28.4062 32.6707 28.4062 31.4297V4.42969C28.4062 3.18867 27.3973 2.17969 26.1562 2.17969ZM18 28.9688C17.223 28.9688 16.5938 28.3395 16.5938 27.5625C16.5938 26.7855 17.223 26.1562 18 26.1562C18.777 26.1562 19.4062 26.7855 19.4062 27.5625C19.4062 28.3395 18.777 28.9688 18 28.9688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIcon3);
export default __webpack_public_path__ + "static/media/blogIcon3.3d2dd870e30f77e7db5e063dcc4f4112.svg";
export { ForwardRef as ReactComponent };